import {
  AmountCell,
  IdCell,
  NameCell,
  PhoneCell,
  StarRating,
} from "@";

// TanStack column defs for the ratings table.
const tableColumns = [
  {
    id: "orderId",
    header: "رقم الطلب",
    size: 110,
    cell: ({ row }) => <IdCell value={row.original.orderId} />,
  },
  {
    id: "donorName",
    header: "الاسم",
    size: 200,
    cell: ({ row }) => <NameCell name={row.original.donorName} />,
  },
  {
    id: "donorPhone",
    header: "رقم الجوال",
    size: 140,
    cell: ({ row }) => <PhoneCell phone={row.original.donorPhone} />,
  },
  {
    id: "orderTotalPrice",
    header: "اجمالي مبلغ الطلب",
    size: 150,
    cell: ({ row }) => (
      <AmountCell value={row.original.orderTotalPrice} tone="emerald" />
    ),
  },
  {
    id: "rating",
    header: "التقييم",
    size: 160,
    cell: ({ row }) => <StarRating rating={row.original.rating} />,
  },
];

export default tableColumns;
